// project imports
import config from 'config';

// action - state management
import * as actionTypes from './action-types';

// hydrate the persisted theme mode so a reload keeps the user's choice
const storedThemeMode =
  typeof window !== 'undefined' ? window.localStorage.getItem('themeMode') : null;

export const initialState = {
  isOpen: ['default'], // for active default menu
  defaultId: 'default',
  fontFamily: config.fontFamily,
  borderRadius: config.borderRadius,
  navType: storedThemeMode || config.navType,
  opened: true
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_THEME_MODE:
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('themeMode', action.navType);
      }
      return {
        ...state,
        navType: action.navType
      };
    default:
      return state;
  }
};

export default customizationReducer;
